import { render, staticRenderFns } from "./BasePhoneInput.vue?vue&type=template&id=6b85eed4&scoped=true&"
import script from "./BasePhoneInput.vue?vue&type=script&lang=js&"
export * from "./BasePhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./BasePhoneInput.vue?vue&type=style&index=0&id=6b85eed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b85eed4",
  null
  
)

export default component.exports